import { Component } from '@angular/core';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Subscription } from 'rxjs';
import { EcatService } from 'src/app/services/ecat.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import heic2any from 'heic2any';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

@Component({
    selector: 'ecat-mobile-homepage',
    templateUrl: './ecat-mobile-homepage.component.html',
    styleUrls: ['./ecat-mobile-homepage.component.less']
})
export class EcatMobileHomepageComponent {
    vinCode: string = '';
    vinError: boolean = false;
    isUploadVisible = false;
    privacyAgreed: boolean = false;
    isPrivacyVisible = false;
    showVideo = false;
    videoSrc: SafeUrl | null = null;
    isLoading = false;
    isDealerPortal: boolean = false;

    constructor(private ecatService: EcatService,
        private router: Router,
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        private message: NzMessageService,
        private sharedDataService: SharedDataService) {
        this.sharedDataService.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }
    checkVinLength(): void {
        this.vinError = this.vinCode.length > 0 && this.vinCode.length !== 17;
    }
    onUploadVinPhoto() {
        this.isUploadVisible = true;
    }
    onHandlePrivacy() {
        this.isPrivacyVisible = true;
    }

    onSearch() {
    }

    onHandleSearch(): void {
        if (this.vinCode.length === 0) {
            this.message.create('warning', '请输入VIN码');
        } else if (this.vinCode.length !== 17) {
            this.message.create('warning', 'VIN码必须为17位字符');
        } else if (!this.privacyAgreed) {
            this.message.create('warning', '请阅读并同意关于VIN码的隐私条款');
        } else {
            this.router.navigate([`gb/cn/parts/ecat-part-list/searchByVin/${this.vinCode}`]);
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_eact_search_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: 'VIN',
                    event_name: '',
                    portal_name: "Mobile " + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: this.vinCode,
                });
            }
        }
    }

    handleOk(): void {
        console.log('Button ok clicked!');
        this.isPrivacyVisible = false;
    }

    handleCancel(): void {
        console.log('Button cancel clicked!');
        this.isPrivacyVisible = false;
    }


    handleUploadOk(): void {
        console.log('Button ok clicked!');
        this.isUploadVisible = false;
    }

    handleUploadCancel(): void {
        console.log('Button cancel clicked!');
        this.isUploadVisible = false;
    }

    openSeachByCarPage() {
        this.router.navigate(['gb/cn/parts/ecat-search']);
    }

    openSeachByProductPage() {
        this.router.navigate(['gb/cn/parts/ecat-search'], { state: { seachByProduct: true } });
    }

    // handleChange = (item: NzUploadXHRArgs): Subscription => {
    //     const file = item.postFile as File;
    //     const sub = new Subscription(); // 创建一个空的 Subscription

    //     const reader = new FileReader();
    //     reader.onload = async () => {
    //         // 1. 预处理文件：如果是 HEIC，先转换为 JPEG Blob；否则保持原样
    //         const processedFile = await this.normalizeFile(file);

    //         // 2. 将文件（Blob/File）转换为 Base64
    //         let base64 = await this.fileToDataURL(processedFile);
    //         const MAX_SIZE = 3 * 1024 * 1024;

    //         if (base64.length > MAX_SIZE) {
    //             base64 = await this.compressImage(base64, MAX_SIZE);
    //         }

    //         this.ecatService.getVinCode({ imageBase64Data: base64, languageType: 'zh-cn' }).subscribe({
    //             next: (result) => {
    //                 const { resultCode, resultData, failure } = result;
    //                 this.isUploadVisible = false;
    //                 console.log('resultData', resultData);
    //                 this.isLoading = false;
    //                 if (failure) {
    //                     this.message.create('error', result.resultMsg);
    //                 } else {
    //                     this.vinCode = resultData?.vinCode;
    //                     this.checkVinLength();
    //                 }
    //             },
    //             error: (err) => {
    //                 this.isLoading = false;
    //                 this.message.create('error', '识别失败');
    //             }
    //         });
    //     };
    //     reader.onerror = (error) => {
    //         this.isLoading = false;
    //         this.message.create('error', '识别失败');
    //     };
    //     reader.readAsDataURL(file);
    //     return sub;
    // };

    openCamera(input: HTMLInputElement): void {
        input.value = '';      // ⭐关键：清空上一次的文件
        input.click();
    }

    clearVin() {
        this.vinCode = '';
    }

    onFileSelected = (event: any): Subscription => {
        this.isLoading = true;
        const file = event.target.files[0];
        const sub = new Subscription(); // 创建一个空的 Subscription

        const reader = new FileReader();
        reader.onload = async () => {
            // 1. 预处理文件：如果是 HEIC，先转换为 JPEG Blob；否则保持原样
            const processedFile = await this.normalizeFile(file);

            // 2. 将文件（Blob/File）转换为 Base64
            let base64 = await this.fileToDataURL(processedFile);
            const MAX_SIZE = 2 * 1024 * 1024;

            if (base64.length > MAX_SIZE) {
                base64 = await this.compressImage(base64, MAX_SIZE);
            }

            this.ecatService.getVinCode({ imageBase64Data: base64, languageType: 'zh-cn' }).subscribe({
                next: (result) => {
                    const { resultCode, resultData, failure } = result;
                    this.isUploadVisible = false;
                    console.log('resultData', resultData);
                    this.isLoading = false;
                    if (failure) {
                        this.message.create('error', result.resultMsg);
                    } else {
                        this.vinCode = resultData?.vinCode;
                        this.checkVinLength();
                    }
                },
                error: (err) => {
                    this.isLoading = false;
                    this.message.create('error', '识别失败');
                }
            });
        };
        reader.onerror = (error) => {
            this.isLoading = false;
            this.message.create('error', '识别失败');
        };
        reader.readAsDataURL(file);
        return sub;
    };

    /**
     * 核心步骤1：文件归一化
     * 解决 PC 端浏览器无法直接解析 HEIC 的问题
     */
    /**
     * 核心步骤1：文件归一化
     * 修复：增加 try-catch 捕获 "already browser readable" 错误
     */
    private async normalizeFile(file: File): Promise<Blob | File> {
        // 判断是否为 heic 格式
        const isHeic = file.type === 'image/heic' ||
            file.name.toLowerCase().endsWith('.heic') ||
            file.type === 'image/heif';

        if (isHeic) {
            try {
                // 尝试转换
                const result = await heic2any({
                    blob: file,
                    toType: 'image/jpeg',
                    quality: 0.9
                });
                return Array.isArray(result) ? result[0] : result;
            } catch (error: any) {
                // 关键修复：
                // 如果 heic2any 抛出 "ERR_USER Image is already browser readable"，
                // 说明浏览器已经自动将 HEIC 转为了 JPEG，我们直接使用原文件即可。
                if (error.code === 1 && error.message.includes('already browser readable')) {
                    console.log('图片已经是可读格式，无需转换');
                    return file;
                }
                // 如果是其他真正的转换错误，则向上抛出
                console.error('HEIC 转换异常:', error);
                throw error;
            }
        }

        // 普通格式直接返回
        return file;
    }

    /**
     * 核心步骤2：读取文件为 Base64
     * 将 FileReader 封装为 Promise
     */
    private fileToDataURL(blob: Blob | File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target?.result as string);
            reader.onerror = (e) => reject(e);
            reader.readAsDataURL(blob);
        });
    }

    private compressImage(base64: string, maxSize: number): Promise<string> {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d')!;

                let width = img.width;
                let height = img.height;

                // --- 1. 尺寸缩放逻辑 ---
                // 限制最大宽度，避免 4000px+ 的超大图占用内存或传输过慢
                const MAX_WIDTH = 2500;
                if (width > MAX_WIDTH) {
                    height = Math.round((height * MAX_WIDTH) / width);
                    width = MAX_WIDTH;
                }

                canvas.width = width;
                canvas.height = height;

                // --- 2. 铺白底 (解决 PNG 透明变黑问题) ---
                // 必须在 drawImage 之前填充背景
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, width, height);

                // --- 3. 绘制图片 ---
                ctx.drawImage(img, 0, 0, width, height);

                // --- 4. 循环压缩逻辑 ---
                let quality = 0.9;
                const mimeType = 'image/jpeg'; // 强制转为 JPG 以支持压缩和 VIN 识别
                let resultBase64 = canvas.toDataURL(mimeType, quality);

                // 只要文件大于 maxSize 且质量还不错(>0.2)，就继续压缩
                while (resultBase64.length > maxSize && quality > 0.2) {
                    quality -= 0.1;
                    // JS 浮点数修正
                    quality = parseFloat(quality.toFixed(1));
                    resultBase64 = canvas.toDataURL(mimeType, quality);
                }

                resolve(resultBase64);
            };

            img.onerror = (err) => {
                reject('图片加载失败，可能是格式不受支持');
            };

            img.src = base64;
        });
    }
    // playVideo() {
    //     const url = '/userCenterAdmin/file/download/72';

    //     this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    //         const rawUrl = URL.createObjectURL(blob);

    //         // 🔥 告诉 Angular 这是安全的 URL
    //         this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);

    //         this.showVideo = true;
    //     });
    // }

}